import { colorPalette } from "_shared/styles/color"
import styled from "styled-components"


const CircleBase = styled.circle`
  transition: stroke-dasharray 0.5s ease-in-out, stroke-dashoffset 0.5s ease-in-out;
  fill: transparent;
  stroke-width: 30;
  stroke-linejoin: bevel;
`

export const Circle1 = styled(CircleBase)`
 stroke: ${colorPalette.saphir};

`
export const Circle2 = styled(CircleBase)`
  stroke: ${colorPalette.lightBlue};
`
export const Circle3 = styled(CircleBase)`
  stroke: ${colorPalette.lighterSaphir};
`

export const LoadingCircle = styled(CircleBase)`
  background: #eee;
	background: linear-gradient(110deg, #ececec 8%, #f5f5f5 18%, #ececec 33%);
	border-radius: 5px;
	background-size: 200% 100%;
	animation: 1.5s shine linear infinite;
	* {
		opacity: 0;
	}
  stroke: #ececec;
  
`
